import { ArticleParagraph1, Button, Image, useDeviceType } from '@cian/ui-kit';
import cn from 'clsx';
import React from 'react';
import { Breadcrumbs, type IBreadcrumbNavItem } from 'shared/components/Breadcrumbs';
import { ContainerInner } from 'shared/components/ContainerInner';
import { ETestIds } from 'shared/constants/testIds';
import styles from './styles.css';

interface IPresentationBlockProps {
  title: string;
  description: string;
  handleClickButton: () => void;
  breadcrumbs: IBreadcrumbNavItem[];
}

export const PresentationBlock: React.FC<IPresentationBlockProps> = ({
  title,
  description,
  handleClickButton,
  breadcrumbs,
}) => {
  const deviceType = useDeviceType();

  const hasBreadcrumbs = breadcrumbs.length > 1;

  return (
    <div className={cn(styles['wrapper'], styles[deviceType])}>
      <ContainerInner>
        <div className={cn(styles['container'], styles[deviceType])} data-testid={ETestIds.PresentationBlock}>
          {hasBreadcrumbs && (
            <div className={cn(styles['breadcrumbs-container'], styles[deviceType])}>
              <Breadcrumbs
                items={breadcrumbs.map((item, index) =>
                  index === 0 ? { ...item, color: 'text-secondary-disabled' } : item,
                )}
              />
            </div>
          )}
          <div className={cn(styles['img'], styles[deviceType])}>
            <Image
              src={'https://static.cdn-cian.ru/frontend/mortgage-assets/mortgage_promo_frontend/cat.png'}
              alt="background"
              preloader
              data-testid={ETestIds.PresentationImg}
            />
          </div>
          <div className={cn(styles['widget'], styles[deviceType])}>
            <div className={styles['widget-main']}>
              <h1 className={cn(styles['title'], styles[deviceType])}>{title}</h1>
              <ArticleParagraph1>{description}</ArticleParagraph1>
              <div className={cn(styles['btn-wrapper'], styles[deviceType])}>
                <Button size={'L'} fullWidth onClick={handleClickButton} data-testid={ETestIds.PresentationBtn}>
                  Подобрать предложение
                </Button>
              </div>
            </div>
          </div>
        </div>
      </ContainerInner>
    </div>
  );
};
